export const menuData = [
  {
    category: "Appetizer",
    items: [
      { name: "Tahu Bakso", description: "Fried tofu stuffed with meatball", price: "25.000" },
      { name: "Singkong Keju", description: "Fried cassava with cheese", price: "20.000" },
      { name: "Spicy Bbq Chicken Wings", description: "Chicken wings with spicy BBQ sauce", price: "35.000" },
      { name: "French Fries", description: "Choice of: Butter, Original, or Seaweed", price: "25.000" },
    ]
  },
  {
    category: "Steak",
    items: [
      { name: "Chicken Chop", description: "Grilled chicken thigh with sauce", price: "45.000" },
      { name: "Crispy Chicken Steak", description: "Deep fried breaded chicken steak", price: "40.000" },
      { name: "Southern Rib's Bbq", description: "BBQ beef ribs", price: "85.000" },
      { name: "Sirloin", description: "Grilled sirloin steak", price: "95.000" },
      { name: "Rib Eye", description: "Grilled rib eye steak", price: "110.000" },
      { name: "Tenderloin", description: "Grilled tenderloin steak", price: "120.000" },
      { name: "Salmon", description: "Pan seared salmon", price: "135.000" },
    ]
  },
  {
    category: "Indonesian Food",
    items: [
      { name: "Bebek Ireng Madura", description: "Madura style black duck with rice", price: "45.000" },
      { name: "Ayam Goreng Sunda", description: "Sundanese fried chicken", price: "35.000" },
      { name: "Ayam Betutu", description: "Balinese spiced chicken", price: "40.000" },
      { name: "Nasi Babat Gongso", description: "Rice with stir-fried tripe", price: "38.000" },
      { name: "Wagyu Krengsengan", description: "Spicy stewed wagyu beef", price: "55.000" },
      { name: "Sate Maranggi", description: "Authentic Purwakarta beef satay served with Tasik-style cikur rice, crackers, and serundeng", price: "45.000" },
      { name: "Bakmi Goreng", description: "Javanese-style fried noodles with shredded chicken", price: "30.000" },
      { name: "Mie Dok-Dok", description: "Traditional noodle soup", price: "28.000" },
      { name: "Nasi Goreng Ayam", description: "Chicken fried rice", price: "30.000" },
      { name: "Nasi Goreng Babat", description: "Authentic Semarang tripe fried rice served with garlic crackers", price: "35.000" },
      { name: "Nasi Goreng Iga", description: "Ribs fried rice", price: "45.000" },
      { name: "Salmon Jimbaran", description: "Nawasena Balinese-style grilled salmon served with Tasik-style cikur rice, serundeng, dabu-dabu salsa, and Jimbaran sauce", price: "85.000" },
    ]
  },
  {
    category: "Pasta",
    items: [
      { name: "Bolognaise", description: "Pasta with meat sauce", price: "40.000" },
      { name: "Creamy Mushroom Pasta", description: "Pasta with creamy mushroom sauce", price: "42.000" },
      { name: "Mac And Cheese", description: "Macaroni with cheese sauce", price: "38.000" },
      { name: "Salmon Aglio E Olio", description: "Pasta with garlic, olive oil, and salmon", price: "55.000" },
      { name: "Carbonara", description: "Pasta with creamy egg and cheese sauce", price: "45.000" },
    ]
  },
  {
    category: "Soup",
    items: [
      { name: "Herb Rib's Soup", description: "Herbal beef rib soup", price: "65.000" },
      { name: "Tongseng", description: "Spicy meat stew with vegetables", price: "45.000" },
      { name: "Soto Betawi", description: "Jakarta style beef soup with coconut milk", price: "45.000" },
    ]
  },
  {
    category: "Pizza",
    items: [
      { name: "Meat Lover Pizza", description: "Sausage, smoked beef, mozzarella cheese, bolognese sauce, beef", price: "75.000" },
      { name: "Beef Yakiniku Pizza", description: "Sliced beef, onion, mushrooms, mozzarella cheese, yakiniku sauce", price: "80.000" },
      { name: "Four Cheese Pizza", description: "Mozzarella, cream cheese, cheddar, red cheddar, onion, pizza sauce", price: "70.000" },
    ]
  },
  {
    category: "Curry Series",
    items: [
      { name: "Crispy Chicken Curry", description: "Rice, omelette, crispy chicken, japanese curry, diced potatoes & carrots", price: "45.000" },
      { name: "Beef Yakiniku Curry", description: "Rice, omelette, beef yakiniku, japanese curry, diced potatoes & carrots", price: "53.000" },
      { name: "Vegetable Omelette Curry", description: "Rice, omelette, japanese curry, diced potatoes & carrots", price: "38.000" },
      { name: "Prawn Tempura Curry", description: "Rice, prawn tempura, japanese curry, diced potatoes & carrots", price: "56.000" },
      { name: "Wagyu Beef Curry", description: "Rice, wagyu beef, japanese curry, diced potatoes & carrots", price: "70.000" },
    ]
  },
  {
    category: "Beverage",
    items: [
      { name: "Strawberry Tea", description: "Refreshing strawberry tea", price: "22.000" },
      { name: "Black Tea (Hot/Ice)", description: "Classic black tea", price: "15.000" },
      { name: "Lemon Tea (Hot/Ice)", description: "Tea with lemon", price: "18.000" },
      { name: "Milk Tea", description: "Tea with milk", price: "20.000" },
      { name: "Peach Tea", description: "Tea with peach flavor", price: "22.000" },
      { name: "Es Jeruk", description: "Fresh orange ice", price: "18.000" },
      { name: "Lychee Tea", description: "Tea with lychee fruit", price: "25.000" },
      { name: "Es Kampoel", description: "Traditional orange drink", price: "18.000" },
    ]
  },
  {
    category: "Signature Coffee",
    items: [
      { name: "Forero Mud Latte", description: "Hazelnut coffee mix with nutella", price: "32.000" },
      { name: "Sugar Crush Tiramisu", description: "Choco chrunchy with tiramisu, and espresso", price: "35.000" },
      { name: "Hazelnut Latte (Hot/Ice)", description: "Hazelnut with coffe milk, peanut butter, and riming peanut", price: "30.000" },
      { name: "Gesha", description: "Banana sakura syrup, with coffee milk and dry rose", price: "32.000" },
      { name: "Jade", description: "Milky matcha with espresso", price: "32.000" },
      { name: "Vanilla Latte (Hot/Ice)", description: "Sweet vanilla with cofee milk and proffle", price: "30.000" },
      { name: "Snuff Brown Coffee", description: "Espresso with palm sugar (espresso dengan gula aren)", price: "28.000" },
      { name: "Coconut Splash", description: "Coconut milk, palm sugar, espresso, and coconut jelly", price: "30.000" },
    ]
  },
  {
    category: "Chocolate Selection",
    items: [
      { name: "Black Charm", description: "Choco base with milky orange", price: "28.000" },
      { name: "Choco Clown", description: "Choco crunchy with tiramisu and espresso", price: "30.000" },
      { name: "New York Night", description: "Dark chocolate blend", price: "30.000" },
      { name: "Es Piscok", description: "Iced banana chocolate drink", price: "25.000" },
      { name: "Hot Chocolate", description: "Warm chocolate drink", price: "25.000" },
    ]
  },
  {
    category: "Non Coffee",
    items: [
      { name: "Matcha (Hot/Ice)", description: "Green tea latte", price: "28.000" },
      { name: "Red Velvet (Hot/Ice)", description: "Red velvet latte", price: "28.000" },
      { name: "Klepon (Hot/Ice)", description: "Traditional pandan and coconut flavor", price: "28.000" },
    ]
  },
  {
    category: "Fresh Juice",
    items: [
      { name: "Dragon Fruit Juice", description: "Fresh dragon fruit", price: "25.000" },
      { name: "Strawberry Juice", description: "Fresh strawberry", price: "25.000" },
      { name: "Apple Juice", description: "Fresh apple", price: "25.000" },
      { name: "Orange Juice", description: "Fresh orange", price: "25.000" },
      { name: "Guava Juice", description: "Fresh guava", price: "25.000" },
      { name: "Watermelon Juice", description: "Fresh watermelon", price: "25.000" },
    ]
  }
];
